import { Icon } from "armstrong-react";
import React from "react";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { FlexiCard } from "./flexiCard";

interface GetInspiredCardProps {
  filterSet?: IListContentParams;
}

export class GetInspiredCard extends React.Component<GetInspiredCardProps, {}> {
  public render() {
    return (
      <FlexiCard
        className="cta-card"
        icomoon={Icon.Icomoon.lamp8}
        title="Bespoke holiday inspiration"
        description="We have a great collection of interesting articles, holiday ideas, reviews, and more to inspire you for your next adventure!"
        cta="Be inspired"
        to={WebRoutes.inspiration(this.props.filterSet)}
      />
    );
  }
}
